<template>
  <div class="net-detect">
    <p class="net-detect-title">{{ languages.smartOrderDetector }}</p>
    <p class="net-detect-desc">
      {{
        detectFinish
          ? languages.smartOrderDetectTip2
          : languages.smartOrderDetectTip
      }}
    </p>
    <template v-if="!detectFinish">
      <van-button
        class="net-detect-btn"
        block
        type="info"
        native-type="button"
        @click="startDetect"
      >
        {{ languages.smartOrderDetect }}
      </van-button>
      <van-progress
        v-if="detecting"
        color="#ed8d1a"
        :percentage="0"
        :show-pivot="false"
        stroke-width="8"
        track-color="#ffffff"
        class="net-detect-progress"
        ref="progress"
      />
      <p class="net-detect-tip" v-if="detecting">
        {{ languages.smartOrderDetecting }}
      </p>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import bridge from '@utiles/bridge';
export default {
  name: 'NetDetect',
  data() {
    return {
      detectFinish: false,
      detecting: false
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.creatework
    })
  },
  methods: {
    simulateProgress() {
      this.detecting = true;
      let percent = 0;
      let interval = setInterval(() => {
        percent += 1;
        this.updateProgress(percent);
        if (percent >= 100) {
          this.detectFinish = true;
          this.detecting = false;
          clearInterval(interval);
        }
      }, 0.3 * 1000);
    },
    updateProgress(percent) {
      this.$refs.progress.$el.querySelector(
        '.van-progress__portion'
      ).style.width = percent + '%';
    },
    startDetect() {
      if (this.detecting) return;
      this.simulateProgress();
      bridge.callSdkMethod('startNetDetect');
      this.$emit('startNetDetect', false);
    }
  }
};
</script>

<style scoped lang="scss">
.net-detect {
  border: 1px dashed #ed8d1a;
  border-radius: 8px;
  padding: 10px 15px;
  background: #fff6e1;
  margin-bottom: 20px;
  &-title {
    text-align: center;
    font-size: 16px;
    color: #ed8d1a;
  }
  &-desc {
    font-size: 14px;
    color: #333333;
    margin: 10px 0 20px 0;
    text-align: center;
    line-height: 25px;
  }
  &-btn {
    border-radius: 6px;
    font-size: 18px;
    background: #ed8d1a;
    height: 50px;
    line-height: 50px;
    border: none;
  }
  &-progress {
    margin: 10px 0;
    border-radius: 0;
    border: 1px solid #ed8d1a;
  }
  &-tip {
    color: #ed8d1a;
    font-size: 14px;
  }
}
</style>
